export const i18nConfig = {
    locales: process.env.LOCALES.split(','),
    defaultLocale: 'default',
    serverSetCookie: 'never',
};
